import * as React from 'react'
import { useEffect, useState } from 'react'
import { useIdleTimer } from 'react-idle-timer'

import PrimaryButton from '../../atoms/Button/Primary/Button'
import Headings from '../../atoms/Heading'
import Paragraph from '../../atoms/Paragraph'
import './style.css'

interface Props {
  content?: any
  background?: string
}

/**
 * Modal Component
 * @param content - Content from the CMS.
 * @param background (optional) - Background color of the component. Expected values: "white" | "purple" | "orange" | "lightPurple" , Default: "white"
 */
const Modal = ({ content, background = 'white' }: Props) => {
  const [modal, setModal] = useState(false)

  const onIdle = () => {
    setModal(true)
  }

  useIdleTimer({
    onIdle,
    timeout: Number(process.env.REACT_APP_MODAL_TIME),
    throttle: 500,
  })

  background = background.toLowerCase()
  const bgColor =
    background === 'purple'
      ? 'bg-purple-100'
      : background === 'orange'
        ? 'bg-orange-10'
        : background === 'teal'
          ? 'bg-teal-10'
          : background === 'lightpurple'
            ? 'bg-purple-10'
            : 'bg-white'

  const handleClose = (e) => {
    e.preventDefault()
    e.stopPropagation()
    window.location.reload()
  }

  useEffect(() => {
    if (!modal) return
    document.querySelectorAll('.customForms').forEach((item: HTMLFormElement) => item?.reset())
    document.querySelector('html').classList.add('overflow-hidden')
  }, [modal])

  return (
    <>
      <div
        data-testid="modal"
        className={`Modal fixed left-0 top-0 z-10 flex h-full w-full items-center justify-center ${modal ? '' : 'hidden'}`}
      >
        <div className={`layout absolute flex flex-col ${bgColor} min-w-[30%] overflow-hidden rounded-lg`}>
          <div className="border-b border-b-neutral-50 p-24">
            <Headings variant="H4" content="Session Expired" classes="text-purple-100 !pb-0" />
          </div>
          <div className="p-24">
            <Paragraph content={'Your session has expired, refreshing the page...'} classes="!text-base" />
          </div>
          <div
            className="flex justify-center p-24"
            onClick={(e) => {
              handleClose(e)
            }}
          >
            <PrimaryButton name="Ok" variant="dark" classes="!text-base px-24 py-8" buttonType="submit" />
          </div>
        </div>
      </div>
    </>
  )
}

export default Modal
